export default __webpack_public_path__ + "static/media/Orbital_Shipyard.7ffc3ff3.jpg";